import { render } from "./emptyImgh5.vue?vue&type=template&id=94a899ec&scoped=true"
import script from "./emptyImgh5.vue?vue&type=script&lang=js"
export * from "./emptyImgh5.vue?vue&type=script&lang=js"

import "./emptyImgh5.vue?vue&type=style&index=0&id=94a899ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a899ec"]])

export default __exports__